export const UPDATE_AUTH_DATA = "UPDATE_AUTH_DATA";
export const HIDE_MODAL = "HIDE_MODAL";